import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'

interface MissMFCBadgeProps {
    missMFCRank?: number
    compact?: boolean
    styleOverrides?: CSSProperties
}
const missMfcStyles = css({
    alignItems: 'center',
    fontWeight: 'bold',
    display: 'flex',
})

const MissMFCBadge = memo((props: MissMFCBadgeProps) => {
    const { styleOverrides = {}, missMFCRank = '', compact } = props

    return (
        <div
            css={missMfcStyles}
            style={{
                ...styleOverrides,
            }}
        >
            {(compact ? '' : 'MFC ') + '#' + missMFCRank}
        </div>
    )
})

export default MissMFCBadge
export { MissMFCBadge }
